// Route `head()` for a tool page: title, description, canonical, Open Graph, and the
// BreadcrumbList and FAQPage JSON-LD (built from the same FAQ the page shows).
import { breadcrumbList, faqPage, jsonLdScript } from '@/lib/schema'
import { BASE_URL, type ToolContent } from '@/lib/tool-content'

export type Crumb = { name: string; path: string }

export function toolCrumbs(content: ToolContent, parent?: { name: string; path: string }): Crumb[] {
  return [
    { name: 'Home', path: '/' },
    { name: 'Tools', path: '/tools' },
    ...(parent ? [{ name: parent.name, path: parent.path }] : []),
    { name: parent ? content.h1 : content.name, path: content.path },
  ]
}

export function toolHead(content: ToolContent, opts: { noindex?: boolean; parent?: { name: string; path: string } } = {}) {
  const url = `${BASE_URL}${content.path}`
  return {
    meta: [
      { title: content.title },
      { name: 'description', content: content.description },
      { property: 'og:title', content: content.title },
      { property: 'og:description', content: content.description },
      { property: 'og:image', content: `${BASE_URL}/og/${content.ogSlug}.png` },
      { property: 'og:url', content: url },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: content.title },
      { name: 'twitter:description', content: content.description },
      ...(opts.noindex ? [{ name: 'robots', content: 'noindex' }] : []),
    ],
    links: [{ rel: 'canonical', href: url }],
    scripts: [
      jsonLdScript(
        breadcrumbList(toolCrumbs(content, opts.parent).map((c) => ({ name: c.name, url: `${BASE_URL}${c.path === '/' ? '' : c.path}` }))),
      ),
      jsonLdScript(faqPage(content.faq.map((f) => ({ question: f.question, answer: f.answer })))),
    ],
  }
}
